(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const forms = document.querySelectorAll('[data-price-promise-contact-form="true"]');

    forms.forEach((form) => {
      const body = form.querySelector('textarea[name="contact[body]"]');
      const fields = [...form.querySelectorAll('[data-price-promise-field]')];
      const fileInputs = [...form.querySelectorAll('[data-price-promise-file]')];
      const status = form.querySelector('[data-price-promise-status]');
      const submitButton = form.querySelector('button[type="submit"]');
      const endpoint = (form.dataset.pricePromiseUploadEndpoint || '').trim();
      const maxSizeMb = Number(form.dataset.pricePromiseMaxSizeMb || 10);
      const maxSizeBytes = maxSizeMb * 1024 * 1024;
      const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];

      if (!body) {
        return;
      }

      const setStatus = (message, type) => {
        if (!status) {
          return;
        }

        status.hidden = false;
        status.textContent = message;
        status.classList.toggle('hdt-form__alert--success', type === 'success');
        status.classList.toggle('hdt-form__alert--error', type === 'error');
      };

      const clearStatus = () => {
        if (!status) {
          return;
        }

        status.hidden = true;
        status.textContent = '';
        status.classList.remove('hdt-form__alert--success', 'hdt-form__alert--error');
      };

      const compileBody = () => {
        const lines = [];

        fields.forEach((field) => {
          const label = (field.dataset.label || '').trim();
          const value = field.value.trim();

          if (label && value) {
            lines.push(`${label} : ${value}`);
          }
        });

        body.value = lines.join('\n');
      };

      if (body.value.trim()) {
        const values = body.value.split(/\r?\n/);

        fields.forEach((field) => {
          const label = (field.dataset.label || '').trim();
          const prefix = `${label} : `;
          const match = values.find((line) => line.startsWith(prefix));

          if (match) {
            field.value = match.slice(prefix.length).trim();
          }
        });
      }

      fileInputs.forEach((input) => {
        const fileNameTargetId = input.dataset.pricePromiseFileName;
        const fileNameTarget = fileNameTargetId ? document.getElementById(fileNameTargetId) : null;

        input.addEventListener('change', () => {
          if (fileNameTarget) {
            fileNameTarget.textContent = input.files && input.files[0] ? input.files[0].name : 'No file selected';
          }

          clearStatus();
        });
      });

      form.addEventListener('submit', async (event) => {
        compileBody();

        if (fileInputs.length === 0) {
          return;
        }

        event.preventDefault();
        clearStatus();

        if (!endpoint) {
          setStatus('Photo upload is not configured yet. Please add the upload endpoint URL in this section settings before publishing this form.', 'error');
          return;
        }

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        for (const input of fileInputs) {
          const file = input.files && input.files[0];

          if (!file) {
            setStatus('Please select both photographs before sending.', 'error');
            return;
          }

          if (!file.type.startsWith('image/') || !allowedTypes.includes(file.type)) {
            setStatus('Please upload JPEG, PNG, WebP, HEIC, or HEIF image files only.', 'error');
            return;
          }

          if (file.size > maxSizeBytes) {
            setStatus(`Each photograph must be ${maxSizeMb} MB or smaller.`, 'error');
            return;
          }
        }

        const formData = new FormData();
        const nameField = form.querySelector('input[autocomplete="name"]');
        const emailField = form.querySelector('input[name="contact[email]"]');

        formData.set('name', (nameField && nameField.value ? nameField.value : '').trim());
        formData.set('email', (emailField && emailField.value ? emailField.value : '').trim());
        formData.set('message', body.value.trim());
        formData.set('page_url', window.location.href);
        formData.set('subject', '3 Month Price Promise claim');

        fileInputs.forEach((input) => {
          if (input.files && input.files[0]) {
            formData.set(input.name, input.files[0]);
          }
        });

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }

        setStatus('Sending your claim...', 'success');

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            body: formData
          });
          const result = await response.json().catch(() => ({}));

          if (!response.ok) {
            throw new Error(result.error || 'There was a problem sending your claim.');
          }

          form.reset();
          body.value = '';
          fileInputs.forEach((input) => {
            const fileNameTargetId = input.dataset.pricePromiseFileName;
            const fileNameTarget = fileNameTargetId ? document.getElementById(fileNameTargetId) : null;

            if (fileNameTarget) {
              fileNameTarget.textContent = 'No file selected';
            }
          });
          setStatus('Thank you. Your claim has been sent.', 'success');
        } catch (error) {
          setStatus(error.message || 'There was a problem sending your claim. Please try again.', 'error');
        } finally {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
